import React from "react";
import PropTypes from "prop-types";

import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { handleLogout } from 'helpers/api_helper';
import Logout from "../../assets/images/Logout Icons.png"


const Confirmlogoutmodal = ({ show, onCloseClick } : any) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
          <ModalBody className="py-3 px-5">
          <div className="mt-2 text-center">
              <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5 LogoutToBE" >
                  <h4>Are you sure you want to be logout?</h4>
                  
               </div>
              </div>
              <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
              <button
                  type="button"
                  className="btn w-sm btn-light"
                  data-bs-dismiss="modal"
                  data-testing-Id="seller_logout_no"
                  onClick={onCloseClick}
                  data-testing-id="logout-no"
              >
                No
              </button>
              <button
                  
                  type="button"
                  onClick={handleLogout || onCloseClick}
                  className="btn w-sm btn-success "
                  data-testing-Id="seller_logout_yes"
                  id="delete-record"
                  data-testing-id="logout-yes"
              >
                Yes
              </button>
              </div>
      </ModalBody>
    </Modal>
  );
};
Confirmlogoutmodal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,

};


export default Confirmlogoutmodal;